import { render, staticRenderFns } from "./MockTime.vue?vue&type=template&id=6a6c2ff5&"
import script from "./MockTime.vue?vue&type=script&lang=js&"
export * from "./MockTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports